'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var reactTable = require('@tanstack/react-table');
var Space = require('../../Space/src/Space.js');
var Head_module = require('../styles/Head.module.less.js');
var Filter = require('./Filter.js');
var Sorter = require('./Sorter.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const Head = (props) => {
    const { header, style, ...restProps } = props;
    const cx = reactUtils.useStyles(Head_module.default);
    const isFilterAvailable = header.column.getCanFilter();
    const isSortAvailable = header.column.getCanSort();
    const containerClassNames = cx('h-p-16', {
        pointer: isSortAvailable || isFilterAvailable,
    });
    return (React__namespace.createElement("th", { colSpan: header.colSpan, style: { width: `${header.getSize()}px`, ...style }, ...restProps }, header.isPlaceholder ? null : (React__namespace.createElement(Space.Space, { className: containerClassNames, onClick: header.column.getToggleSortingHandler(), align: "center", size: 4 },
        React__namespace.createElement("div", { className: cx('cell') }, reactTable.flexRender(header.column.columnDef.header, header.getContext())),
        React__namespace.createElement(Space.Space, { size: 0, align: "center", className: cx('icons'), inline: true },
            isSortAvailable ? React__namespace.createElement(Sorter.Sorter, { isSorted: header.column.getIsSorted() }) : null,
            isFilterAvailable ? React__namespace.createElement(Filter.Filter, { column: header.column }) : null)))));
};

exports.Head = Head;
//# sourceMappingURL=Head.js.map
